import { render, staticRenderFns } from "./DeliveryPostalCode.vue?vue&type=template&id=c15d308c"
import script from "./DeliveryPostalCode.vue?vue&type=script&lang=ts"
export * from "./DeliveryPostalCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports